import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchMerchantInfo } from 'Services';
import { saveState } from 'utils/LocalStorage';
import { LANGUAGE } from 'utils/CONSTANT';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const merchantInfo = createAsyncThunk('get/merchantInfo', FetchMerchantInfo);

export const MerchantInfoSlice = createSlice({
	name: 'merchantInfo',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[merchantInfo.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[merchantInfo.rejected.toString()]: setAPIError,
		[merchantInfo.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[MerchantInfoSlice.name]: ReturnType<typeof MerchantInfoSlice.reducer>;
}

export const merchantSelector = (state: IStates): any => {
	return state[MerchantInfoSlice.name] || {};
};

export const useMerchantInfo = (): any => useSelector(merchantSelector);

export const fetchMerchantInfo =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		//const appInfo = await NativeSupportHandlerLegacy.getAppInfo();
		await dispatch(merchantInfo({}));
		return;
	};

export const resetMerchantInfo =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(MerchantInfoSlice.actions.RESET());
		return;
	};
